<div *ngFor="let toast of toasts"
     [class]="'toast ' + toast.cssClass"
     [ngClass]="{'is-detailed': isToastWithDetails(toast)}"
     (mouseenter)="cancelTimeout(toast)"
     (mouseleave)="restartTimeout(toast)"
     [@toastAnim]>
  <div class="toast_container" (click)="close(toast)">
    <div class="toast_icon" [class]="toast.icon"></div>
    <div class="toast_message">
      <div class="toast-title" *ngIf="hasTitle(toast)">
        {{toast.title}}
      </div>
      <div class="toast-content" [ngClass]="{'has-no-title': !hasTitle(toast)}" [innerHTML]="toast.content" *ngIf="toast.content"></div>
    </div>
  </div>
  <div *ngIf="isToastWithDetails(toast)" class="toast-detail">
    <button class="button-white-icon" (click)="copyToClipboard(toast)">
      <i class="icon icon-clipboard"></i>
    </button>
    <button class="button-white-icon" (click)="fermerToast(toast)">
      <i class="icon icon-x"></i>
    </button>
    <div *ngIf="isCopyOnClipboard(toast)" class="copy-clipboard" [@fadeInOut]>
      Les détails ont été copiés dans votre presse-papier
    </div>
  </div>
</div>
